import MenuPageItem from "./MenuPageItem";

export default function MenuPageItemDelete({ formUtility, onClick }) {

    function handleOnClick(e) {
        if (!onClick || formUtility.fieldsDisabled)
            return;

        formUtility.setDeleteInProgress(true);

        formUtility.showPrompt(
            "Delete",
            "Permanently delete this record?",
            () => onClick().finally(() => formUtility.setDeleteInProgress(false)),
            null,
            () => formUtility.setDeleteInProgress(false)
        );
    }

    return (
        <>
            {
                onClick && formUtility.data && !formUtility.hasChanges
                    ? <MenuPageItem iconClassName={formUtility.deleteInProgress ? "fa fa-spinner fa-pulse" : "fas fa-trash"} text="DELETE" onClick={handleOnClick} />
                    : null
            }
        </>
    );
}